import { ScoreFragment } from '@/shared/graphql/ScoreFragment.generated';

const getDefaultTopTen = (leaderboard?: ScoreFragment[]) => [
  leaderboard?.slice(0, 10),
  [],
];

export default getDefaultTopTen;
